const isArraysEqual = (a, b) => {
  return Array.isArray(a) &&
      Array.isArray(b) &&
      a.length === b.length &&
      a.every((val, index) => b.includes(val));
}

const findObjectByKeyValue = (array, value, key) => {
  return array.find(function(obj){
    return obj[key] === value
  })
}

export {
  isArraysEqual,
  findObjectByKeyValue
};


// WEBPACK FOOTER //
// ./src/helpers/array_helpers.js